import { render, staticRenderFns } from "./testDrive.vue?vue&type=template&id=2e5b4de0&scoped=true&"
import script from "./testDrive.vue?vue&type=script&lang=js&"
export * from "./testDrive.vue?vue&type=script&lang=js&"
import style0 from "./testDrive.vue?vue&type=style&index=0&id=2e5b4de0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b4de0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5b4de0')) {
      api.createRecord('2e5b4de0', component.options)
    } else {
      api.reload('2e5b4de0', component.options)
    }
    module.hot.accept("./testDrive.vue?vue&type=template&id=2e5b4de0&scoped=true&", function () {
      api.rerender('2e5b4de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/testDrive.vue"
export default component.exports